import React from "react";

const PublicHealth = () => {
  return (
    <div className="container lg:pb-[2vw] pb-[4vw] leading-tight text-center font-redhatRegular lg:pt-[1vw] pt-[1.5vw] lg:px-[1vw] px-[2vw] text-primary">
      <p>
        Public health helpline For any health concerns or queries related to
        Ebola disease, contact the Airport Health Officer at Terminal health
        desks or call - <a className="underline text-blue-600" href="tel:1075">1075</a> the national helpline. Report to the health desk before
        immigration clearance if you have symptoms.
      </p>
    </div>
  );
};

export default PublicHealth;
